import axios from 'utility/wpAxios'
import { constructWPURL } from 'utility/query'

export const fetchEducationPosts = async () => {
  try {
    let _query = {
      page: 1,
      per_page: 50,
      embed: true,
    }
    let requestUrl = constructWPURL('/education_posts', _query)
    const res = await axios.get(requestUrl)
    const _posts = res.data

    return _posts
  } catch (err) {
    console.log('Error: ', err)
  }
}

export const fetchEducationPostBySlug = async (slug) => {
  try {
    let _query = {
      embed: true,
      slug,
    }

    let requestUrl = constructWPURL('/education_posts', _query)
    const res = await axios.get(requestUrl)
    const _posts = res.data
    let _foundPost

    if (Array.isArray(_posts) && _posts.length > 0) {
      _foundPost = _posts[0]
    }

    return _foundPost
  } catch (err) {
    console.log('Error: ', err)
  }
}


export const fetchEducationPostCategories = async () => {
  try {
    let _query = {
      page: 1,
      per_page: 100,
      embed: true,
    }
    let requestUrl = constructWPURL('/education_post_categories', _query)
    const res = await axios.get(requestUrl)
    const _categories = res.data
    return _categories
  } catch (err) {
    console.log('Error: ', err)
  }
}